import * as datatableModule from '../../../shared/location/claim/datatable.js';

angular.module('pmtPlacesApp.controllers').controller('ClaimFacebookOverviewCtrl', [
	'$scope',
	'$stateParams',
	'$http',
	'$timeout',
	'auth',
	'Geo',
	'pmtAlertService',
	'pmtElmService',
	function ($scope, $stateParams, $http, $timeout, auth, Geo, pmtAlertService, pmtElmService) {
		$scope.site = $stateParams.site;
		$scope.getfacebookspreadsheetUrl = 'api/' + encodeURI($scope.site) + '/export/facebook/claim';
		$scope.begin = 0;
		$scope.showLinkPageDialoge = false;
		$scope.linkPage = null;
		$scope.linkPlace = null;
		$scope.hasLocationFinderRun = false;

		$scope.userIsAdmin = auth.user.isAdmin;
		const selectedSite = auth.user.selectedSite;
		$scope.hasPageToken = selectedSite.places.facebook.hasPageToken;
		$scope.hasCategory =
			selectedSite.places.facebook.subcategories &&
			selectedSite.places.facebook.subcategories.length > 0;
		$scope.facebookMainPage = selectedSite.places.facebook.data;

		$scope.reviewAndCreateListArgs = {
			siteName: $stateParams.site,
			pmtEnv: window.pmtEnv,
			googleBusinessAccounts: []
		};

		$scope.reviewAndCreateListSubscriptions = [
			{
				id: 'close',
				f: () => $timeout(() => ($scope.showCreateListPopup = false))
			}
		];

		$scope.closeServerError = function () {
			$scope.serverError = null;
		};

		const setError = function (defaultMsg) {
			return function (err) {
				$scope.serverError =
					(err && err.data && err.data.data ? err.data.data : null) || err.statusText || defaultMsg;
				console.error('_getExistingPages!_', err);
			};
		};

		const getExistingPages = function () {
			$scope.existingPages = [];
			$http
				.get('api/' + $scope.site + '/facebook/claim/pagesmatchinglocations')
				.then(function (res) {
					$scope.existingPages = (res.data.data || []).map(function (x) {
						x.place.mapConfiguration = {
							location: x.place.location,
							iconType: 'pinmeto'
						};

						x.pages.map(function (y) {
							y.distance = Geo.calculateDistance(
								x.place.location.lat,
								x.place.location.lon,
								y.location.lat,
								y.location.lon
							);
							y.mapConfiguration = {
								location: y.location,
								iconType: 'facebook'
							};
							return y;
						});

						return x;
					});
				})
				.catch(setError('Fetching matching locations failed'));
		};

		const getNotMatchedLocations = function () {
			$http
				.get('api/' + $scope.site + '/facebook/claim/notmatchedlocations')
				.then(function (res) {
					$scope.notMatchedLocations = res.data.data.map(m => {
						return Object.assign({}, m.data, { _id: m._id });
					});
					$scope.datatable = datatableModule.init({
						data: $scope.notMatchedLocations,
						element: '#facebook-not-matched-locations-datatable',
						onSelect: item => {
							$scope.selectedLocation = item;
							$scope.$apply();
						}
					});
				})
				.catch(setError('Fetching not matched locations failed'));
		};

		const getCorrectClaimStatus = function () {
			$http
				.get('api/' + $scope.site + '/facebook/claim/status')
				.then(function (res) {
					$scope.loadingFacebookLocations = false;
					$scope.claimed = res.data.claimed;
					$scope.notClaimed = res.data.notClaimed;
					getNotMatchedLocations();
				})
				.catch(setError('Fetching claim status failed'));
		};

		const getLastRunStatus = function () {
			$http
				.get('api/' + $scope.site + '/facebook/locationfinderstatus')
				.then(function (res) {
					$scope.locationFinderLastRun = res.data.lastRun;
				})
				.catch(setError('Fetching location finder status failed'));
		};

		const updateFacebookLocations = function () {
			$scope.hasLocationFinderRun = 'running';
			$http
				.get('api/' + $scope.site + '/facebook/locationsfind')
				.then(function (res) {
					$scope.locationFinderLastRun = res.data.lastRun;
					if (res.data.success) {
						$scope.hasLocationFinderRun = 'done';
						getCorrectClaimStatus();
					} else {
						$scope.hasLocationFinderRun = 'error';
					}
				})
				.catch(setError('Update location finder status failed'));
		};

		const resetWizard = function () {
			$scope.begin = 0;
		};

		$scope.runLocationFinder = updateFacebookLocations;

		$scope.next = function () {
			$scope.begin = $scope.begin + 1;
			updateFacebookLocations();
			if ($scope.begin === $scope.existingPages.length) {
				resetWizard();
				getExistingPages();
			}
		};

		if ($scope.hasPageToken) {
			getExistingPages();
			$scope.loadingFacebookLocations = true;
			getCorrectClaimStatus();
			getLastRunStatus();
		}

		const removePageFromExistingList = function (page) {
			$scope.existingPages.map(function (res) {
				res.pages = res.pages.filter(function (p) {
					return p.id !== page.id;
				});
				return res;
			});
		};

		$scope.closeLinkPageDialog = function () {
			$scope.linkPage = null;
			$scope.linkPlace = null;
			$scope.showLinkPageDialoge = false;
		};

		$scope.showLinkPageDialog = function (place, page) {
			$scope.linkPage = page;
			$scope.linkPlace = place;
			$scope.showLinkPageDialoge = true;
		};

		const displayAlert = function (title, body) {
			pmtAlertService.alert({
				title: title,
				body: body,
				confirmTitle: 'Ok',
				confirm: function () {
					pmtAlertService.close();
				}
			});
		};

		$scope.addPageToLocations = function () {
			const placeId = $scope.linkPlace._id;
			const postBody = {
				facebookId: $scope.linkPage.id
			};

			$scope.showAddLocationProgress = true;
			$http
				.put(
					'api/' + $scope.site + '/place/' + placeId + '/facebook/locations/addExisting',
					postBody
				)
				.then(function (res) {
					if (res.data.success) {
						removePageFromExistingList($scope.linkPage);
						$scope.closeLinkPageDialog();
						$scope.showAddLocationProgress = false;
						$scope.next();
					} else {
						$scope.showAddLocationProgress = false;
						const data = res.data.data;
						const errorMessage = (() => {
							if (data.userMessage && data.userTitle) {
								return `Error link page: ${data.userTitle} - ${data.userMessage}`;
							} else if (data.userMessage || data.message) {
								return 'Error link page: ' + (data.userMessage || data.message);
							} else if (data.raw?.message) {
								return `${data.raw?.message}`;
							}
							return `Error link page: ${data}`;
						})();
						console.log(data);
						displayAlert('Error', errorMessage);
					}
				});
		};

		const removePageFromPlace = function (placeId, page) {
			$scope.existingPages.map(function (res) {
				if (res.place._id === placeId) {
					res.pages = res.pages.filter(function (p) {
						return p.id !== page.id;
					});
					if (res.pages.length === 0) {
						$scope.next();
					}
				}
			});
		};

		$scope.ignorePageSuggestion = function (place, pageData) {
			const postBody = {
				pageData: pageData
			};

			$http
				.post(
					'api/' + $scope.site + '/place/' + place._id + '/facebook/claim/existingpage/ignore',
					postBody
				)
				.then(function (res) {
					if (res.data.success) {
						removePageFromPlace(place._id, pageData);
					} else {
						displayAlert('Error', res.data.data);
					}
				});
		};

		$scope.showCreateList = function () {
			$scope.showCreateListPopup = true;
			$timeout(() => {
				pmtElmService.sendData(
					'Tasks.Facebook.ReviewAndCreate.Main',
					'in_Tasks_Facebook_ReviewAndCreate_Main_argsChanged',
					$scope.reviewAndCreateListArgs
				);
			});
		};

		const getUnverifiedCount = () => {
			$http
				.get(`api/${$scope.site}/places/unverified/count`)
				.then(res => {
					const { count } = res.data;

					$scope.unverifiedCount = count;
				})
				.catch(err => {
					displayAlert('Error', err.message || err);
				});
		};
		getUnverifiedCount();
	}
]);
